import { ToastrService } from 'ngx-toastr';
import { OcrResponse } from '../interfaces/ui/ocr.interface';
import { GEMINI_EXTRACTION_TYPES, GEMINI_WARNING_ACTIONS } from '../constants/constants';

const MISSING_FIELD_LABELS: Record<string, string> = {
  monto: 'monto',
  banco_nombre: 'banco origen',
  id_banco: 'banco origen',
  banco_catalog_match: 'banco origen',
  id_comprobante: 'número de comprobante',
  beneficiario: 'beneficiario',
  fecha: 'fecha',
  id_banco_empresa: 'banco destino',
  banco_empresa: 'banco destino',
  banco_empresa_nombre: 'banco destino',
};

function formatMissingFields(fields?: string[] | null): string {
  if (!Array.isArray(fields) || fields.length === 0) return '';
  const unique = Array.from(
    new Set(fields.map((f) => MISSING_FIELD_LABELS[f] || f)),
  );
  return unique.join(', ');
}

export function showOcrPartialWarning(
  toastrSvc: ToastrService,
  res: OcrResponse,
): boolean {
  const warning = res?.data?.warning;
  if (warning?.code !== GEMINI_EXTRACTION_TYPES.PARTIAL) return false;

  const missingLabels = formatMissingFields(warning.missingFields);
  const backendMessage =
    res.message?.trim() ||
    'No se pudieron extraer todos los datos requeridos del comprobante.';
  const detailLine = missingLabels
    ? `Campos a revisar: ${missingLabels}.`
    : '';
  const fullMessage = [backendMessage, detailLine].filter(Boolean).join('\n');

  const options = {
    timeOut: 8000,
    closeButton: true,
    enableHtml: false,
    progressBar: true,
  };

  if (warning.action === GEMINI_WARNING_ACTIONS.MANUAL) {
    toastrSvc.info(fullMessage, 'Complete los campos pendientes', options);
  } else {
    toastrSvc.warning(
      fullMessage,
      'Intente con otra imagen más clara',
      options,
    );
  }
  return true;
}
